import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import {
  CompanyListQuery,
  CompanyDirectoryRepository,
} from '@app/domain/ports/tpv/company-directory.repository';
import { TpvCompany } from '@app/domain/models/tpv/company-directory.model';
import { TpvCompanyDetail } from '@app/domain/models/tpv/entity-detail.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';

/** Mock del directorio de empresas para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class CompanyDirectoryMockDataSource extends CompanyDirectoryRepository {
  private readonly companies: TpvCompany[] = [
    { idCompany: 'mock-company-1', name: 'Empresa Demo 1', legalName: 'Demo 1 SA de CV', rfc: 'XAXX010101000', status: 'active', entity: 'MX', totalUnits: 3 },
    { idCompany: 'mock-company-2', name: 'Empresa Demo 2', legalName: 'Demo 2 SA de CV', rfc: 'XAXX010101001', status: 'inactive', entity: 'MX', totalUnits: 1 },
    { idCompany: 'mock-company-3', name: 'Empresa Demo 3', legalName: 'Demo 3 SA de CV', rfc: 'XAXX010101002', status: 'active', entity: 'MX', totalUnits: 5 },
  ];

  override getCompanies(query: CompanyListQuery = {}): Observable<TpvPage<TpvCompany>> {
    // `search` es el filtro nuevo (contrato 2026-09-29): OR entre nombre, razón
    // social y RFC. `merchantName` sigue soportado como back-compat (mismo alcance
    // pero solo por nombre) para code paths que aún no migraron.
    const term = (query.search ?? query.merchantName ?? '').toLowerCase().trim();
    let filtered = this.companies;
    if (term) {
      if (query.search) {
        filtered = filtered.filter(
          (c) =>
            c.name.toLowerCase().includes(term) ||
            c.legalName.toLowerCase().includes(term) ||
            (c.rfc ?? '').toLowerCase().includes(term),
        );
      } else {
        filtered = filtered.filter(
          (c) => c.name.toLowerCase().includes(term) || c.legalName.toLowerCase().includes(term),
        );
      }
    }
    return of({
      data: filtered,
      total: filtered.length,
      page: query.page ?? 1,
      limit: query.limit ?? 10,
    }).pipe(delay(300));
  }

  override getById(orgIdCompany: number | string): Observable<TpvCompanyDetail> {
    const c = this.companies[0];
    return of<TpvCompanyDetail>({
      idCompany: c.idCompany,
      orgIdCompany: Number(orgIdCompany) || 1000,
      name: c.name,
      socialName: c.legalName,
      entity: c.entity,
      rfc: c.rfc,
      represent: 'Representante Demo',
      status: c.status,
      totalUnits: c.totalUnits,
      address: { state: 'Ciudad de Mexico', city: 'CDMX', cp: '06000', neighborhood: 'Centro', town: 'Cuauhtemoc', street: 'Calle Demo', extNumber: '1', intNumber: 'A', description: 'Mock' },
      contact: { name: 'Contacto Demo', rol: 'Admin', email: 'demo@empresa.mx', telephonePrincipal: '5555555555' },
      bank: { bank: '012', card: '4152313333334444', numAccount: '1234567890', clabe: '012180012345678901' },
    }).pipe(delay(300));
  }
}
